import {is_function} from '../../Helpers/js/simple.functions';
import $ from 'jquery';
import LP from './0-lp';

LP.filters = {
  params: new Array(),
  dispatching: false,

  init: function (params) {
    var rootId = $(params.root).attr('id');
    var root = params.root;

    LP.filters.params[rootId] = params;
    $('.lp-filter', root).each(function (i, e) {
      LP.filters.initFilter($(e));
    });
    //LP.filters.initFilters(root);
    LP.filters.checkFilters(root);
  },

  getRoot: function (element) {
    return $(element).closest('.lp-filters');
  },
  getParams: function (root) {
    var rootId = $(root).attr('id');
    return LP.filters.params[rootId];
  },

  initFilter: function (filter) {
    if (!filter) {
      return;
    }

    $('a[action="addFilter"]', filter).click(LP.filters.addFilterHere);
    $('a[action="clearFilter"]', filter).click(LP.filters.clearFilter);
    $('a[action="deleteFilter"]', filter).click(LP.filters.deleteFilter);
    $('select.filterPredicate', filter).change(function () {
      var filter = $(this).closest('.lp-filter');
      LP.filters.onChangePredicate(filter, $(this));
    });

    // init each term
    $('.filterTerm', filter).each(function (index, item) {
      LP.filters.term.init(item, true);
    });

    //hide first condition
    LP.filters.onChangePredicate(filter, $('select.filterPredicate', filter));
  },

  checkFilters: function (root) {
    var filters = $('.lp-filter-items .lp-filter', root);
    if (filters.length === 0) {
      LP.filters.addFilter(root);
    }

    LP.filters.checkFilterTerms(root);
  },

  checkFilterTerms: function (root) {
    if (LP.filters.dispatching) {
      return;
    } else {
      LP.filters.dispatching = true;
    }
    if (!root) {
      return;
    }
    var params = LP.filters.getParams(root);
    if (params && is_function(params.onUpdate)) {
      params.onUpdate(root);
    }

    // Add first term, if filter is empty
    $('ul.lp-filter-terms', root).each(function (index, filter) {
      filter = $(filter);
      if (filter.length === 0 || filter.html().length <= 1) {
        LP.filters.term.add(filter);
      }
    });

    LP.filters.updateIndices(root);
    LP.filters.dispatching = false;
  },

  addFilter: function (root) {
    if (!root) {
      return;
    }
    var filterItems = $('.lp-filter-items', root);

    if ($('.lp-filter-new-filter-holder', root).length > 0) {
      var newFilter = $($('.lp-filter-new-filter-holder', root).html());

      filterItems.append(newFilter);

      LP.filters.initFilter(newFilter);
      LP.filters.checkFilters(LP.filters.getRoot(newFilter));

      var params = LP.filters.getParams(root);
      if (is_function(params.onAddFilter)) {
        params.onAddFilter(newFilter);
      }
      return true;
    } else {
      return false;
    }
  },

  addFilterHere: function (root) {
    if (!root) {
      return;
    }

    var filter = $(this).closest('.lp-filter');
    //var filterItems =  filter.closest('.lp-filter-items');
    var filterHolder = filter.closest('.lp-filters');

    var newFilter = $($('.lp-filter-new-filter-holder', filterHolder).html());
    newFilter.insertAfter($(filter));

    LP.filters.initFilter(newFilter);
    LP.filters.checkFilters(filterHolder);

    var params = LP.filters.getParams(root);
    if (params && is_function(params.onAddFilter)) {
      params.onAddFilter(newFilter);
    }
  },

  clearFilter: function () {
    var filter = $(this).closest('.lp-filter');
    var filterHolder = filter.closest('.lp-filters');

    LP.UI.warnConfirm($('.lp-filter-confirm-filter-clear', filterHolder).html(), function () {
      $('.lp-filter-terms', filter).html('');
      LP.filters.checkFilters(filterHolder);
      var params = LP.filters.getParams(filterHolder.parent());

      if (params && is_function(params.onClearFilter)) {
        params.onClearFilter(filter);
      }
    });
  },

  deleteFilter: function (root) {
    if (!root) {
      return;
    }
    var filter = $(this).closest('.lp-filter');
    var filterHolder = filter.closest('.lp-filters');
    LP.UI.warnConfirm($('.lp-filter-confirm-filter-delete', filterHolder).html(), function () {
      filter.remove();
      LP.filters.checkFilters(filterHolder);
    });
  },

  removeEmptyFilters: function (root) {
    var filterHolder = $('.lp-filter-items', root);

    $('.lp-filter', filterHolder).each(function (index, filter) {
      filter = $(filter);
      if (filter.isVisible()) {
        var filterList = $('ul.lp-filter-terms', filter);
        $('li.filterTerm', filterList).each(function (index, term) {
          if ($(term).isVisible()) {
            var selector = $('[role="selector"]', term);
            if (selector && !selector.val()) {
              $(term).remove();
            }
          }
        });
        if (filterList.length === 0 || filterList.html().length <= 1) {
          filter.remove();
        }
      }
    });

    LP.filters.checkFilters(root);
  },

  removeEmptyTerms: function (filter) {
    var filterHolder = $('.lp-filter-items', filter);

    $('li.filterTerm', filterHolder).each(function (index, term) {
      if ($(term).isVisible()) {
        var selector = $('[role="selector"]', term);
        if (selector && !selector.val()) {
          $(term).remove();
        }
      }
    });
    LP.filters.checkFilterTerms(filter);
  },

  onChangePredicate: function (filter, select) {
    var predicate = select.val();
    if (predicate === 'ANY') {
      $('[role="condition"]', filter).show().first().hide();
      //$('.termCondition-select',filter).first().hide();
    } else {
      $('[role="condition"]', filter).hide();
    }
  },

  updateIndices: function (root) {
    if (!root) {
      return;
    }
    var filters = $('.lp-filter-items', root);

    // Anzeige für die Filter-Nummer (1,2,3...) updaten
    $('.filterNum', filters).each(function (index, element) {
      $(element).html(index + 1);
    });

    // Alle Filter durchlaufen
    $('.lp-filter-terms', filters).each(function (index, element) {
      // für jeden Term den Filter-Index setzen zur Referenze
      $('.filterIndex', element).each(function () {
        this.value = index;
      });

      // für jeden Term den Term-Index setzen zur Referenze
      $('.termIndex', element).each(function (pos, elm) {
        $(elm).val(pos);
      });
    });
  },

  term: {
    init: function (term, usePreset) {
      var $term = $(term);

      $('a[action="addTerm"]', $term).click(LP.filters.term.addTermHere);
      $('a[action="deleteTerm"]', $term).click(LP.filters.term.deleteTerm);

      // add condition-<select> (AND / OR) to term (with defaultValue)
      LP.filters.term.addConditionSelect($term, usePreset);

      // add selector-<select> (Questions/Pages/..) to term
      LP.filters.term.addSelectorSelect($term, usePreset);

      // add class .wide-tag to selector-selects, that have certain selector-type
      var selector = $('[role="selector"]', $term);
      var selectorType = $('option:selected', selector).attr('selector-type');
      if (selectorType === 'PAGE' || selectorType === 'QILIST') {
        selector.addClass('wide-tag');
      }

      // call external callback
      var root = LP.filters.getRoot($term);
      var params = LP.filters.getParams(root);

      if (params && is_function(params.onInitTerm)) {
        params.onInitTerm($term);
      }
    },

    add: function (filter) {
      var filterHolder = filter.closest('.lp-filters');
      var newTerm = $($('.lp-filter-new-term-holder ul', filterHolder).html());
      filter.append(newTerm);
      LP.filters.term.init(newTerm, false);
      LP.filters.updateIndices(filterHolder);
      //var params = LP.filters.getParams(root);
      //if (params && is_function(params.onAddTerm)) params.onAddTerm(newTerm);
    },

    addTermHere: function () {
      var term = $(this.parentNode);
      var filterDiv = term.closest('.lp-filters');

      var newTerm = $($('.lp-filter-new-term-holder ul', filterDiv).html());
      newTerm.insertAfter(term);
      LP.filters.updateIndices(filterDiv);
      LP.filters.term.init(newTerm, false);

      var root = LP.filters.getRoot(term);
      var params = LP.filters.getParams(root);
      if (params && is_function(params.onAddTerm)) {
        params.onAddTerm(newTerm);
      }
    },

    addConditionSelect: function (term, usePreset) {
      var root = term.closest('.lp-filters');
      var templates = $('#lp-filter-templates', root);

      // create clone for condition (AND / OR)
      var condition = $('[role="condition"][template="1"]', templates).clone().removeAttr('template');
      condition.change(function () {
        LP.filters.term.onChangeCondition($(this), term);
      });
      if (usePreset) {
        condition.val($('.termCondition', term).val());
      }

      // hide contition-select, if predicate != ANY
      var predicate = $('.filterPredicate', term.closest('.lp-filter')).val();
      if (predicate === 'ANY') {
        condition.show();
      } else {
        condition.hide();
      }

      // hide condition in first term
      $('[role="condition"]', term.closest('.lp-filter')).first().hide();
      // remove previous condition and add condition html
      $('.termConditionHolder', term).html('').append(condition);
    },

    addSelectorSelect: function (term, usePreset) {
      var root = term.closest('.lp-filters');
      var templates = $('#lp-filter-templates', root);

      var selector = $('select[template="1"][role="selector"]', templates).clone().removeAttr('template');

      if (usePreset) {
        var val = $('.termSelector', term).val();
        var type = $('.termSelectorType', term).val();

        if (val && type) {
          $('option[value="' + val + '"][selector-type="' + type + '"]', selector).prop('selected', true);
        }
      }

      $('.termSelectorHolder', term).html('').append(selector);

      LP.filters.term.onChangeSelector(selector, term, usePreset);
      selector.change(function () {
        LP.filters.term.onChangeSelector($(this), term, false);
      });

      selector.show();
    },

    addElementSelect: function (term, usePreset) {
      var root = term.closest('.lp-filters');
      var templates = $('#lp-filter-templates', root);
      var termSelector = $('.termSelector', term).val();
      var selectorType = $('.termSelectorType', term).val();

      var cssStr = '[role="element"][template="1"][selector-type="' + selectorType + '"]';
      var elementType = $('[role="selector"] option:selected', term).attr('element-type');
      if (elementType != 'static') {
        cssStr += '[selector="' + termSelector + '"]';
      }

      var elementTemplate = $(cssStr, templates);
      if (elementTemplate.length === 0) {
        var onLoad = function (json) {
          templates.append($(json.html));
          elementTemplate = $(cssStr, templates);
        };

        window.Browser.send('backend/getTermElementsTemplate/', 'selector=' + termSelector + '&type=' + selectorType, onLoad, null, false);
      }

      // Clone element template select
      var elementClone = elementTemplate.clone().removeAttr('template');
      elementClone.val(usePreset ? $('.termElement', term).val() : '');
      elementClone.change(function () {
        LP.filters.term.onChangeElement($(this), term, false);
      });
      elementClone.show();
      $('.termElementHolder', term).html('').append(elementClone);

      LP.filters.term.onChangeElement(elementClone, term, usePreset);
    },

    addAnswerElement: function (term, usePreset) {
      var root = term.closest('.lp-filters');
      var templates = $('#lp-filter-templates', root);
      var termSelector = $('.termSelector', term).val();
      var selectorType = $('.termSelectorType', term).val();
      var termElement = $('.termElement', term).val();

      var answerElement = LP.filters.term.findAnswerTemplate(term, termSelector, selectorType, termElement);

      // Reload answer selector element if not present
      if (!answerElement || answerElement.length === 0) {
        var onLoad = function (json) {
          templates.append($(json.html));
          answerElement = LP.filters.term.findAnswerTemplate(term, termSelector, selectorType, termElement);
        };
        window.Browser.send(
          'backend/getTermAnswersTemplate/',
          'selector=' + termSelector + '&element=' + termElement + '&type=' + selectorType,
          onLoad,
          null,
          false // send sychron!
        );
      }

      if (answerElement.length === 0) {
        return;
      }

      // jetzt fängt das clonen an und ersetzen von ids etc etc....könnte in ne eigene funktion, muss aber nicht
      // Clone template answer element
      var answerClone = answerElement.clone().removeAttr('template');
      if (!answerClone) {
        return;
      }

      var answerInput = '';
      var cloneTag = answerClone[0].tagName;
      if (!cloneTag) {
        return;
      }

      if (cloneTag === 'SELECT') {
        answerInput = answerClone;
      } else if (cloneTag === 'SPAN') {
        answerInput = $('input', answerClone);
      } else if (cloneTag === 'INPUT') {
        answerInput = answerClone;
      }

      var cloneScript = answerClone.attr('onclone');
      answerClone.removeAttr('onclone');

      if (cloneTag == 'SPAN' || cloneTag == 'INPUT') {
        answerInput.keypress(function (e) {
          if (e.keyCode == 13) {
            e.preventDefault();
          }
        });
      }

      // Replace id for id-missmatchings
      if (answerInput.attr('id')) {
        var uid =
          Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1) +
          Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        var newId = answerInput.attr('id').replace('_ftmpl', '_' + uid);

        answerInput.attr('id', newId);
        if (cloneScript) {
          cloneScript = cloneScript.replace(/%clone%/gi, newId);
        }
      }

      if (usePreset) {
        answerInput.val($('.termAnswer', term).val());
      }
      answerInput.change(function () {
        LP.filters.term.onChangeAnswer(this, term);
      });

      if (cloneScript) {
        cloneScript = cloneScript.replace(/%parent%/gi, 'answerClone');
        eval(cloneScript);
      }

      // Add & Show Clone
      $('.termAnswerHolder', term).html('').append(answerClone);
      answerClone.show();
      LP.filters.term.onChangeAnswer(answerInput, term);
    },

    findAnswerTemplate: function (term, termSelector, selectorType, termElement) {
      var root = term.closest('.lp-filters');
      var templates = $('#lp-filter-templates', root);

      // Detect template answer element
      var cssStr = '[role="answer"][template="1"][selector-type="' + selectorType + '"]';
      var answerType = $('[role="element"] option:selected', term).attr('answer-type');
      var answerTemplate;

      if (answerType == 'static') {
        cssStr += '[selector="' + termSelector + '"]:not([element])';
        answerTemplate = $(cssStr, templates);
      } else if (answerType == 'semi-static') {
        var ids = termElement.split('_');
        while (ids.length > 0) {
          answerTemplate = $(cssStr + '[selector="' + termSelector + '"][element="' + ids.join('_') + '"]', templates);
          if (answerTemplate.length > 0) {
            break;
          }
          ids.pop();
        }
      } else {
        cssStr += '[element="' + termElement + '"]';
        answerTemplate = $(cssStr, templates);
      }

      return answerTemplate;
    },

    addOperationsSelect: function (term, usePreset) {
      var root = term.closest('.lp-filters');
      var templates = $('#lp-filter-templates', root);
      var answerType = $('[role="element"] option:selected', term).attr('var-type') === 'NUMERIC' ? 'numeric' : 'bool';

      var operationsClone = $('[role="operation"][template="1"][op-types="' + answerType + '"]', templates)
        .clone()
        .removeAttr('template');
      $('.termOperationHolder', term).html('').append(operationsClone);
      if (usePreset) {
        operationsClone.val($('.termOperation', term).val());
      }

      LP.filters.term.onChangeOperation(operationsClone, term);
      operationsClone.change(function () {
        LP.filters.term.onChangeOperation(this, term);
      });
    },

    deleteTerm: function () {
      var term = $(this).closest('.filterTerm');
      var filter = term.closest('.lp-filter');
      var filterHolder = filter.closest('.lp-filters');

      LP.UI.warnConfirm($('.lp-filter-confirm-term-delete', filterHolder).html(), function () {
        term.remove();
        LP.filters.checkFilterTerms(filterHolder);
        var root = LP.filters.getRoot(filter);
        var params = LP.filters.getParams(root);
        if (params && is_function(params.onDeleteTerm)) {
          params.onDeleteTerm();
        }
      });
    },

    onChangeCondition: function (select, term) {
      $('.termCondition', term).val(select.val());
    },

    onChangeSelector: function (select, term, usePreset) {
      var termSelector = select.val();
      var selectedOption = $('option:selected', select);
      var selectorType = selectedOption.attr('selector-type');

      if (termSelector !== $('.termSelector', term).val() || selectorType !== $('.termSelectorType', term).val()) {
        $('.termSelector', term).val(termSelector);
        $('.termSelectorType', term).val(selectorType);
        var root = LP.filters.getRoot(select);
        var params = LP.filters.getParams(root);
        if (params && is_function(params.onChangeSelector)) {
          params.onChangeSelector();
        }
      }

      if (!termSelector) {
        select.addClass('wide-tag');
        LP.filters.term.resetTermElement(term);
        LP.filters.term.resetTermOperation(term);
        LP.filters.term.resetTermAnswer(term);
      } else {
        // hide operation & answer for Pages
        if (selectorType === 'PAGE' || selectorType === 'QILIST') {
          LP.filters.term.resetTermOperation(term);
          LP.filters.term.resetTermAnswer(term);
        } else {
          select.removeClass('wide-tag');
        }

        LP.filters.term.addElementSelect(term, usePreset);
      }
    },

    onChangeElement: function (select, term, usePreset) {
      var termElement = select.val();

      if (termElement !== $('.termElement', term).val()) {
        $('.termElement', term).val(termElement);
        var root = LP.filters.getRoot(select);
        var params = LP.filters.getParams(root);
        if (params && is_function(params.onChangeElement)) {
          params.onChangeElement();
        }
      }

      var selectorType = $('.termSelectorType', term).val();
      var answerType = $('[role="element"] option:selected', term).attr('answer-type');

      if (selectorType === 'QUST') {
        if (termElement === '-1' || termElement === '-2' || termElement === '-3') {
          select.addClass('wide-tag');

          LP.filters.term.resetTermOperation(term);
          LP.filters.term.resetTermAnswer(term);

          return;
        } else {
          select.removeClass('wide-tag');
        }
      } else if (selectorType === 'QUOT') {
        /* empty */
      } else if (selectorType === 'RESV') {
        select.removeClass('wide-tag');
      } else if (selectorType === 'ACTION') {
        select.removeClass('wide-tag');
      }

      if (!termElement || selectorType === 'PAGE' || answerType === 'none') {
        select.addClass('wide-tag');
        LP.filters.term.resetTermOperation(term);
        LP.filters.term.resetTermAnswer(term);
      } else {
        // add operations-<select> (=,>,<,...)
        LP.filters.term.addOperationsSelect(term, usePreset);

        // add answers-<select/spinbox/input> (je nach ausgewähltem termElement)
        LP.filters.term.addAnswerElement(term, usePreset);
      }
    },

    onChangeOperation: function (input, term) {
      var op = $(input).val();
      var termOp = $('.termOperation', term);

      if (termOp.val() !== op) {
        termOp.val(op);
        var root = LP.filters.getRoot(input);
        var params = LP.filters.getParams(root);
        if (params && is_function(params.onChangeAnswer)) {
          params.onChangeAnswer();
        }
      }
    },

    onChangeAnswer: function (input, term) {
      var $input = $(input);
      var value;
      var answerType = $input.attr('answer-type');

      switch (answerType) {
        case 'date':
          value = $(input).closest('.ui.calendar').datepicker('getDate');
          break;
        case 'time':
          value = $(input).closest('.ui.calendar').datepicker('getTime');
          break;
        default:
          value = $(input).val();
      }

      var termAnswer = $('.termAnswer', term);

      if (termAnswer.val() !== value) {
        termAnswer.val(value);
        var root = LP.filters.getRoot(input);
        var params = LP.filters.getParams(root);
        if (params && is_function(params.onChangeAnswer)) {
          params.onChangeAnswer();
        }
      }
    },

    resetTermElement: function (term) {
      $('.termElement', term).val('');
      $('.termElementHolder', term).html('');
    },
    resetTermOperation: function (term) {
      $('.termOperation', term).val('EQ');
      $('.termOperationHolder', term).html('');
    },
    resetTermAnswer: function (term) {
      $('.termAnswer', term).val('');
      $('.termAnswerHolder', term).html('');
    },
  },
};
